import { render, staticRenderFns } from "./OrderItemHandOver.vue?vue&type=template&id=01cd84b9"
import script from "./OrderItemHandOver.vue?vue&type=script&lang=js"
export * from "./OrderItemHandOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports